import { useEffect, useState } from 'react'

export function useCountdown(initialCount: number) {
  const [count, setCount] = useState(initialCount)
  const [hasFinished, setHasFinished] = useState(false)

  useEffect(() => {
    if (count > 0) {
      const timer = setTimeout(() => setCount(count - 1), 1000)
      return () => clearTimeout(timer)
    } else {
      setHasFinished(true)
    }
  }, [count])

  const start = () => {
    setCount(initialCount)
    setHasFinished(false)
  }

  return { count, hasFinished, start }
}
